export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Agu',
    'Sep',
    'Okt',
    'Nov',
    'Des',
  ],
  months: [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ],
  months_calendar: {
    January: 'Januari',
    February: 'Februari',
    March: 'Maret',
    April: 'April',
    May: 'Mei',
    June: 'Juni',
    July: 'Juli',
    August: 'Agustus',
    September: 'September',
    October: 'Oktober',
    November: 'November',
    December: 'Desember',
  },
  // weekdays
  weekdays: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
  weekdays_booking_container: {
    Sunday: 'Minggu',
    Monday: 'Senin',
    Tuesday: 'Selasa',
    Wednesday: 'Rabu',
    Thursday: 'Kamis',
    Friday: 'Jumat',
    Saturday: 'Sabtu',
  },
  weekdays_calendar: {
    Sun: 'Min',
    Mon: 'Sen',
    Tue: 'Sel',
    Wed: 'Rab',
    Thu: 'Kam',
    Fri: 'Jum',
    Sat: 'Sab',
  },
  // additional translations
  today: 'Hari ini',
  tomorrow: 'Besok',
};
